import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/crm/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id },
          { withCredentials: true }
        );
        setUser(data.user);
        window.history.replaceState(null, "", "/crm");
        navigate("/crm", { replace: true, state: { user: data.user } });
      } catch (err) {
        const detail = err?.response?.data?.detail || "Login failed. Please try again.";
        navigate("/crm/login", { replace: true, state: { error: detail } });
      }
    })();
  }, [navigate, location, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-black">
      <div className="text-sm tracking-overline uppercase text-black/50 dark:text-white/50">
        Signing you in…
      </div>
    </div>
  );
}
